import Immunology from './Immunology';

export default Immunology;
